import { LineItem, ShippingRate } from "@stripe/stripe-js";
import { amountToMinorUnits, getCartStore } from "../utils";
import { ShippingMethodDto } from "../api";



    export function mapLineItemsForStripe() : Array<LineItem> {
        return getCartStore().items.map((item) => {
            return {
                name: item.quantity + "x " + item.name,
                amount: amountToMinorUnits(item.total.value.withTax)
            }
        }) ?? [];
    }
    export function mapShippingMethodForStripe(shippingMethods: ShippingMethodDto[]) : Array<ShippingRate> {
        return shippingMethods.map((method) => {
            const rate = method.rates.length > 0 ? method.rates[0] : null;
            return {
                id: method.id,
                amount: amountToMinorUnits(rate?.value.withTax ?? 0),
                displayName: method.name,
            };
        });
    }